import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FtcAttributeEditService {

  constructor(private http: HttpClient) {}

  saveDefaults(baseUrl: string, globalParams: any, filterParams: any, settings: any, details: any[]): Observable<any> {
    const mergedParams: any = { ...globalParams, ...filterParams };
    mergedParams.clob_data = JSON.stringify(details);
    mergedParams.clob_settings = JSON.stringify(settings);
    mergedParams.process_name = 'attributes-grid-save';

    const body = new URLSearchParams();
    Object.keys(mergedParams).forEach(k => {
      if (mergedParams[k] !== undefined && mergedParams[k] !== null) {
        body.set(k, String(mergedParams[k]));
      }
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(
      `${baseUrl}/saveJsonAsPivotObject?action_code=1rs6lg`,
      body.toString(),
      { headers, withCredentials: true }
    );
  }
}
